<div class="facial-recognition-image-uploader">
  <fgb-facial-recognition-uploader-header
    facialRecognitionHeading="{{ 'facial.recognition.review.photo.heading' | translate }}"
    facialRecognitionSubheading="{{ 'facial.recognition.review.photo.subheading' | translate }}"
    [stepCounter]="stepCounter"
    [showCloseButton]="true"
    (setStep)="setStep.emit($event)"
    (previousStepChange)="previousStepChange.emit()"
  ></fgb-facial-recognition-uploader-header>

  <div class="container facial-recognition-details-div mt-3 text-center">
    <div class="border facial-recognition-photo-div mb-2">
      <img
        *ngIf="imageSrc || uploadedImage.value"
        [src]="uploadedImage.value || imageSrc"
        width="100%"
        height="100%"
        alt="facial-recognition-details"
      />
    </div>
    <div class="font-size-14 review-photo-details-heading">
      {{ 'facial.recognition.review.photo.details.heading' | translate }}
    </div>
    <div class="font-size-14 review-photo-details-subheading">{{ 'facial.recognition.review.photo.details' | translate }}</div>
  </div>

  <div class="container facial-recognition-buttons-div">
    <div class="d-lg-flex gap-3 align-items-center justify-content-center">
      <div class="mb-lg-0 mb-2 facial-recognition-review-photo-button">
        <fgb-facial-recognition-uploader-button
          [uploadedImage]="uploadedImage"
          [formData]="formData"
          [facialRecognitionButtonType]="4"
          (retakePhoto)="retakePhoto()"
        ></fgb-facial-recognition-uploader-button>
      </div>
      <div class="facial-recognition-review-photo-button">
        <fgb-facial-recognition-uploader-button
          [facialRecognitionButtonType]="5"
          (submitphoto)="submitphoto()"
        ></fgb-facial-recognition-uploader-button>
      </div>
    </div>
  </div>
</div>
